"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var ButtonWrap_1 = require("./ButtonWrap");
function Button(props) {
    var type = props.type, onClick = props.onClick, href = props.href, children = props.children, block = props.block, other = tslib_1.__rest(props, ["type", "onClick", "href", "children", "block"]);
    return (React.createElement("div", null,
        (type === "primary" || undefined) && (React.createElement(ButtonWrap_1.PrimaryButton, tslib_1.__assign({ onClick: onClick, block: block }, other), children)),
        type === "default" && (React.createElement(ButtonWrap_1.DefaultButton, tslib_1.__assign({ onClick: onClick, block: block }, other), children)),
        type === "danger" && (React.createElement(ButtonWrap_1.DangerButton, tslib_1.__assign({ onClick: onClick, block: block }, other), children)),
        type === "link" && (React.createElement(ButtonWrap_1.LinkButton, tslib_1.__assign({ href: href }, other), children))));
}
exports.Button = Button;
Button.protoTypes = {
    children: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
};
Button.defaultProps = {
    children: "Button",
    type: "primary",
    onClick: function () { },
};
//# sourceMappingURL=index.js.map